/**
 * Precios en formato argentino ($42.000).
 *
 * La tienda trabaja en pesos argentinos (ARS) con el formato
 * `${{amount_no_decimals_with_comma_separator}}`, asi que Shopify ya imprime los
 * precios como se leen aca. Este archivo queda igual como red de seguridad: reescribe
 * cualquier precio que salga con formato yanqui ("$42,000.00") o con centavos
 * ("$42.000,00") a "$42.000". Los precios que ya vienen formateados por
 * `snippets/precio-ars.liquid` no se tocan.
 */
(function () {
  var SOLO_MONEDA = /^\s*(USD|ARS|\$)?\s*$/;
  var PARTES = /^([^\d]*)(\d[\d,]*(?:\.\d+)?)(.*)$/;
  var PESOS_CON_CENTAVOS = /^([^\d]*)(\d{1,3}(?:\.\d{3})+),00(.*)$/;

  /** Convierte "42,000.00" en "42.000". Devuelve null si no hace falta. */
  function aPesos(texto) {
    var m = String(texto || '').match(PARTES);
    if (!m) return null;
    if (!/,/.test(m[2])) return null; // sin separador de miles: ya esta bien
    if (m[3] && !SOLO_MONEDA.test(m[3])) return null; // no es un precio solo
    var numero = m[2].replace(/,/g, '').replace(/\.\d+$/, '');
    if (!/^\d+$/.test(numero)) return null;
    return m[1] + numero.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  /** Saca los centavos en cero de "$42.000,00" y deja "$42.000". */
  function sinCentavos(texto) {
    var m = String(texto || '').match(PESOS_CON_CENTAVOS);
    if (!m) return null;
    if (m[3] && !SOLO_MONEDA.test(m[3])) return null; // no es un precio solo
    return m[1] + m[2] + m[3];
  }

  function arreglar(nodo) {
    if (!nodo || nodo.nodeType !== 1) return;
    var lista = [];
    if (nodo.classList && nodo.classList.contains('money')) lista.push(nodo);
    if (nodo.querySelectorAll) lista = lista.concat(Array.prototype.slice.call(nodo.querySelectorAll('.money')));
    for (var i = 0; i < lista.length; i++) {
      var el = lista[i];
      if (el.dataset && el.dataset.precioOk === '1') continue;
      var nuevo = sinCentavos(el.textContent) || aPesos(el.textContent);
      if (!nuevo) { if (el.dataset) el.dataset.precioOk = '1'; continue; }
      el.textContent = nuevo;
      if (el.dataset) el.dataset.precioOk = '1';
    }
  }

  var pendiente = false;
  var observador = new MutationObserver(function () {
    if (pendiente) return;
    pendiente = true;
    window.requestAnimationFrame(function () {
      pendiente = false;
      arreglar(document.body);
    });
  });

  function iniciar() {
    arreglar(document.body);
    observador.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
